const Title = () => {
  return (
    <section className="w-full flex flex-col h-[800px] mobile:h-[250px]">
      <section className="flex-[1]"></section>
      <section className="flex-[2] flex flex-col justify-center items-center overflow-hidden">
        <img
          src="/images/name.png"
          alt="name"
          className="w-[60%] mobile:w-[95%]"
        />
      </section>
    </section>
  );
};

export default Title;
